import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  getAboutusFailure,
  getAboutusSuccess,
  getCookiesFailure,
  getCookiesSuccess,
  getHomedataFailure,
  getHomedataSuccess,
  getPrivacyPolicyFailure,
  getPrivacyPolicySuccess,
  getSubscriptionpolicyFailure,
  getSubscriptionpolicySuccess,
  getTermandCondFailure,
  getTermandCondSuccess,
  PrivacyPolicyFailure,
  PrivacyPolicySuccess,
  setAboutusFailure,
  setAboutusSuccess,
  setCookiesFailure,
  setCookiesSuccess,
  setHomedataFailure,
  setHomedataSuccess,
  setSubscriptionpolicyFailure,
  setSubscriptionpolicySuccess,
  setTermandCondFailure,
  setTermandCondSuccess,
} from '../../Redux/Actions/ContentManageAction';
import {
  ABOUT_US,
  COOKIES,
  GET_ABOUT_US,
  GET_COOKIES,
  GET_HOME_DATA,
  GET_PRIVACY_POLICY,
  GET_SUBSCRIPTION_POLICY,
  GET_TERM_CONDITION,
  PRIVACY_POLICY,
  SUBSCRIPTION_POLICY,
  TERM_CONDITION,
  UPDATE_HOME_DATA,
} from '../../Redux/Actiontype';
import { Basepath } from '../../config';

export const PrivacyPolicyEpic = action$ =>
  action$.pipe(
    ofType(PRIVACY_POLICY),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updatePrivacyPolicy`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(
              //   routeRules.dashboard,
              //   toast.success(response.response.Message)
              // );
              return of(PrivacyPolicySuccess(response.response));
            } else {
              return of(PrivacyPolicyFailure(response.response));
            }
          }),
        ),
    ),
  );

export const AboutusEpic = action$ =>
  action$.pipe(
    ofType(ABOUT_US),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updateAboutus`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(
              //   routeRules.dashboard,
              //   toast.success(response.response.Message)
              // );
              return of(setAboutusSuccess(response.response));
            } else {
              return of(setAboutusFailure(response.response));
            }
          }),
        ),
    ),
  );

export const TermandCondEpic = action$ =>
  action$.pipe(
    ofType(TERM_CONDITION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updateTermOfConditions`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(
              //   routeRules.dashboard,
              //   toast.success(response.response.Message)
              // );
              return of(setTermandCondSuccess(response.response));
            } else {
              return of(setTermandCondFailure(response.response));
            }
          }),
        ),
    ),
  );

export const CookiesEpic = action$ =>
  action$.pipe(
    ofType(COOKIES),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updateCookies`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(setCookiesSuccess(response.response));
            } else {
              return of(setCookiesFailure(response.response));
            }
          }),
        ),
    ),
  );

export const getPrivacyPolicyEpic = action$ =>
  action$.pipe(
    ofType(GET_PRIVACY_POLICY),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/privacy_policy`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            // history.push(
            //   routeRules.dashboard,
            //   toast.success(response.response.Message)
            // );
            return of(getPrivacyPolicySuccess(response.response));
          } else {
            return of(getPrivacyPolicyFailure(response.response));
          }
        }),
      ),
    ),
  );

export const getAboutusEpic = action$ =>
  action$.pipe(
    ofType(GET_ABOUT_US),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/about_us`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            // history.push(
            //   routeRules.dashboard,
            //   toast.success(response.response.Message)
            // );
            return of(getAboutusSuccess(response.response));
          } else {
            return of(getAboutusFailure(response.response));
          }
        }),
      ),
    ),
  );

export const getTermandCondEpic = action$ =>
  action$.pipe(
    ofType(GET_TERM_CONDITION),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/terms_conditions`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            // history.push(
            //   routeRules.dashboard,
            //   toast.success(response.response.Message)
            // );
            return of(getTermandCondSuccess(response.response));
          } else {
            return of(getTermandCondFailure(response.response));
          }
        }),
      ),
    ),
  );

export const getCookiesEpic = action$ =>
  action$.pipe(
    ofType(GET_COOKIES),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/cookies`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            return of(getCookiesSuccess(response.response));
          } else {
            return of(getCookiesFailure(response.response));
          }
        }),
      ),
    ),
  );

export const getSubsriptionpolicyEpic = action$ =>
  action$.pipe(
    ofType(GET_SUBSCRIPTION_POLICY),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/subscription`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            // history.push(
            //   routeRules.dashboard,
            //   toast.success(response.response.Message)
            // );
            return of(getSubscriptionpolicySuccess(response.response));
          } else {
            return of(getSubscriptionpolicyFailure(response.response));
          }
        }),
      ),
    ),
  );

export const SubscriptionpolicyEpic = action$ =>
  action$.pipe(
    ofType(SUBSCRIPTION_POLICY),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updateSubscription`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(
              //   routeRules.dashboard,
              //   toast.success(response.response.Message)
              // );
              return of(setSubscriptionpolicySuccess(response.response));
            } else {
              return of(setSubscriptionpolicyFailure(response.response));
            }
          }),
        ),
    ),
  );

export const getHomedataEpic = action$ =>
  action$.pipe(
    ofType(GET_HOME_DATA),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/landingPage`).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            // history.push(
            //   routeRules.dashboard,
            //   toast.success(response.response.Message)
            // );
            return of(getHomedataSuccess(response.response));
          } else {
            return of(getHomedataFailure(response.response));
          }
        }),
      ),
    ),
  );

export const HomedataEpic = action$ =>
  action$.pipe(
    ofType(UPDATE_HOME_DATA),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/updateLandingPage`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(
              //   routeRules.dashboard,
              //   toast.success(response.response.Message)
              // );
              return of(setHomedataSuccess(response.response));
            } else {
              return of(setHomedataFailure(response.response));
            }
          }),
        ),
    ),
  );
